import { v4 as uuidv4 } from "uuid";
export class TagModel {
    constructor() {
        this.id = uuidv4();
        this.tagName = "";
        this.description = "";
    }
}
export default class Tag extends TagModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
